import { DownloadSimpleIcon } from "@phosphor-icons/react/DownloadSimple";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { useState } from "react";
import { isNetworkError } from "@/Helpers/isNetworkError";

interface ShipmentDocumentDownloadButtonProps {
  onDownloadDocument: () => Promise<void>;
  "data-testid"?: string | undefined;
}

// Fetching a document can take a few seconds, and until the file lands the
// customer has no other sign the click did anything — so the button spins
// until it does.
export function ShipmentDocumentDownloadButton(
  props: ShipmentDocumentDownloadButtonProps,
) {
  const { onDownloadDocument } = props;
  const [downloading, setDownloading] = useState(false);

  // A download that gets no answer at all (a phone dropping its connection)
  // is a console warning, not a Sentry event; any other failure is rethrown
  // so it still reaches Sentry.
  async function handleClick() {
    setDownloading(true);
    try {
      await onDownloadDocument();
    } catch (error) {
      if (!isNetworkError(error)) throw error;
      console.warn("Could not download the document", { error });
    } finally {
      setDownloading(false);
    }
  }

  // `label` shows as text in a dialog header; elsewhere the children do.
  return (
    <Button
      icon={DownloadSimpleIcon}
      label="Download"
      loading={downloading}
      onClick={handleClick}
      data-testid={props["data-testid"]}
    >
      Download
    </Button>
  );
}
